export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "",
  headLine: "About The Company",
  description:
    "The five-storey wellness hub for Taguigeño senior citizens was opened last April, and features a therapy pool, a massage room, two saunas, a yoga room, a gym, and cinema for relaxation purposes. It also comes with a dialysis center to accommodate 15 patients at a time, and a multi-purpose hall for city programs and recreational activities.",
  buttonLabel: 'Learn More',
  imgStart: true,
  img: require("../../../images/center.png"),

  alt: "Car",
  dark: true,
  primary: true,
  darkText: false
};
